import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Stack, IconButton, Typography, Box } from "@mui/material";
import dayjs from "dayjs";
import { t } from "i18next";
import { CalendarLegend } from "./calenderLegend";
var CalendarToolbar = function (_ref) {
    var date = _ref.date, onNavigate = _ref.onNavigate, count = _ref.count;
    return /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        py: 1,
        px: 2,
        border: "1px solid",
        borderColor: "secondary.200",
        borderBottom: "none",
        borderRadius: "8px 8px 0 0",
        gap: 3
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 2
    }, /*#__PURE__*/ React.createElement(IconButton, {
        color: "secondary",
        onClick: function () { return onNavigate('PREV'); }
    }, /*#__PURE__*/ React.createElement(ChevronLeft, {
        sx: {
            height: 24,
            width: 24
        }
    })), /*#__PURE__*/ React.createElement(Typography, {
        ml: 1,
        fontSize: "xl",
        fontWeight: "medium"
    }, dayjs(date).format('MMMM YYYY')), /*#__PURE__*/ React.createElement(IconButton, {
        color: "secondary",
        onClick: function () { return onNavigate('NEXT'); }
    }, /*#__PURE__*/ React.createElement(ChevronRight, {
        sx: {
            height: 24,
            width: 24
        }
    }))), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        columnGap: 1,
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: "medium",
        fontSize: "xl"
    }, count), /*#__PURE__*/ React.createElement(Typography, {
        color: "text.secondary",
        fontSize: "xl"
    }, t('total appointments'))), /*#__PURE__*/ React.createElement(CalendarLegend, null)));
};
export default CalendarToolbar;
